import { css } from 'lit';

export const style = css`
  /* stylelint-disable selector-type-no-unknown */
  fs-body-text {
    margin-top: 1em;
  }

  fs-radio {
    margin-top: 1em;
  }

  .modal-container {
    margin-top: 1em;
    text-align: center;
  }

  fs-modal-dialog > p {
    text-align: left;
  }

  strong {
    font-weight: 600;
  }
  /* stylelint-enable selector-type-no-unknown */
`;
